// extracted by mini-css-extract-plugin
export default {"cls1":"DW1jbzHhylcIS4PBPMxw","cls2":"CxccEstcWZkqWmB6XupF DW1jbzHhylcIS4PBPMxw"};